<template>
  <v-container>
      <h1 class="text-center" id="page-heading">404 - Page Not Found</h1>
      <BackHome />
  </v-container>
</template>

<script>
import BackHome from '../components/BackHome'
export default {
  name: 'notfound',
  components: {
    BackHome
  },
  data: () => ({
    
  }),
};
</script>
